import React, { useState } from 'react';
import Preloader from '../components/Preloader'
import Footer from '../components/Footer';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import ScrollReveal from '../components/ScrollReveal';
import Header from '../components/Header';

const generalFaqs = [
    {
        question: 'What is Querencia Micro Credit?',
        answer: 'Querencia Micro Credit is a licensed financial institution in Ghana dedicated to providing tailored financial solutions. We offer credit facilities to individuals, salaried workers, and Small and Medium-sized Enterprises (SMEs) to support their personal and business growth.',
    },
    {
        question: 'How long does the loan processing take?',
        answer: 'We understand the urgency of financial needs. Once all required documentation is submitted and verified, our loan processing typically takes between 24 to 48 hours for approval and disbursement.',
    },
    {
        question: 'Do I need collateral to apply for a loan?',
        answer: 'Collateral requirements depend on the type of loan product. Salary loans generally do not require physical collateral. However, SME and business loans may require some form of security depending on the loan amount and risk assessment.',
    },
    {
        question: 'What are the interest rates?',
        answer: 'Our interest rates are competitive and compliant with industry standards. The specific rate depends on the loan product, tenure, and the applicant\'s credit profile. Please contact our office for a personalized quote.',
    },
];

const requirementFaqs = [
    {
        question: 'Requirements for SME & Business Loans',
        answer: (
            <ul className="list-disc pl-5 space-y-2">
                <li>Valid Business Registration Documents (Certificate of Incorporation & Commencement of Business).</li>
                <li>Valid National ID of the Proprietor/Directors (Ghana Card).</li>
                <li>Bank Statements for the last six (6) months.</li>
                <li>Proof of Business Location (Utility Bill or Tenancy Agreement).</li>
                <li>One (1) recent passport-sized photographs.</li>
                <li>Sketch of direction to business location and residence.</li>
            </ul>
        ),
    },
    {
        question: 'Requirements for Salary Loans',
        answer: (
            <ul className="list-disc pl-5 space-y-2">
                <li>Valid National ID (Ghana Card).</li>
                <li>Three (3) most recent payslips.</li>
                <li>Bank Statements for the last six (6) months reflecting salary credits.</li>
                <li>One (1) recent passport-sized photographs.</li>
                <li>Proof of Residence (Utility Bill or Tenancy Agreement).</li>
                <li>Completed Loan Application Form.</li>
            </ul>
        ),
    },
];

const Faqs = () => {
    const [activeId, setActiveId] = useState(null);

    const toggleQuestion = (id) => {
        setActiveId(activeId === id ? null : id);
    };

    const renderAccordion = (items, sectionPrefix) => (
        <div className="space-y-4">
            {items.map((item, index) => {
                const id = `${sectionPrefix}-${index}`;
                const isOpen = activeId === id;
                
                return (
                    <div key={id} className="border border-gray-200 rounded-lg overflow-hidden transition-all duration-300 hover:shadow-md bg-white">
                        <button
                            className={`w-full flex justify-between items-center p-5 text-left transition-colors duration-300 ${isOpen ? 'bg-blue-50 text-blue-900' : 'bg-white text-gray-800 hover:bg-gray-50'}`}
                            onClick={() => toggleQuestion(id)}
                        >
                            <span className="text-sm font-semibold font-nixie-one">{item.question}</span>
                            <span className={`transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''} text-blue-600`}>
                                {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                            </span>
                        </button>
                        <div 
                            className={`transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
                        >
                            <div className="p-5 border-t text-sm border-gray-100 text-gray-600 leading-relaxed font-semibold">
                                {item.answer}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );

    return (
        <div className='font-nixie-one bg-gray-50 min-h-screen text-gray-800'>
            <Header />
            <Preloader />
            <main>
                {/* Hero Section */}
                <section className="relative h-[40vh] md:h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('/assets/faqs.jpg')" }}>
                    <div className="absolute inset-0 bg-blue-900/60 flex items-center justify-center">
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                        <div className="text-center text-white px-4">
                            <h1 className="text-2xl md:text-3xl font-bold mb-4 tracking-wide">Frequently Asked Questions</h1>
                            <p className="text-sm md:text-sm max-w-2xl mx-auto font-light">Find answers to common questions and detailed requirements for our credit facilities.</p>
                        </div>
                        </ScrollReveal>
                    </div>
                </section>

                {/* FAQ Content */}
                <section className="py-16 md:py-24 px-4">
                    <div className="container mx-auto max-w-4xl">
                        
                        {/* General FAQs Section */}
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1}>
                            <div className="mb-12">
                                <h2 className="text-base md:text-base font-bold text-blue-900 mb-6 border-l-4 border-blue-600 pl-4">General FAQs</h2>
                                {renderAccordion(generalFaqs, 'general')}
                            </div>
                        </ScrollReveal>

                        {/* Loan Requirements Section */}
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                            <div>
                                <h2 className="text-base md:text-base font-bold text-blue-900 mb-6 border-l-4 border-blue-600 pl-4">Loan Requirements</h2>
                                {renderAccordion(requirementFaqs, 'req')}
                            </div>
                        </ScrollReveal>

                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default Faqs